import React from 'react';
import '../App.css';
import './ClinicalSupervision.css'
import { motion } from 'framer-motion';
import Header from './CSSupervisors.png';
import { Link } from 'react-router-dom';
import Matt from './Matt.png';
import Tracy from '../Tracy.jpg';

class CSStory extends React.Component {
    render() {
        return (
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
            >
                <h1 className='full-heading'>Tracy Bertrim</h1>
                <div className='twocol rev'>
                    <div>
                        <p>Tracy Bertrim (she/her) is a Registered Psychotherapist and clinical supervisor, and a graduate of the Master of Arts in Counselling and Spirituality program at Saint Paul University. With over 6 years of experience as a clinical supervisor, she is passionate about clinical supervision and therapist development, offering a safe, supportive, and non-judgmental space where supervisees can build confidence, deepen self-awareness, and strengthen their clinical skills.</p>
                        <p>Tracy has over 12 years of clinical experience working with individuals and families across the lifespan, with clinical specializations in ADHD, anxiety, and trauma. Her work is trauma-informed and person-centered, with a strong emphasis on individualized care and thoughtful case conceptualization.</p>
                        <p>In both therapy and supervision, Tracy draws from evidence-based approaches including Cognitive Behavioral Therapy (CBT), Dialectical Behaviour Therapy (DBT), Acceptance and Commitment Therapy (ACT), and mindfulness. She supports supervisees in integrating theory with practice, navigating complex clinical situations, and developing their own authentic therapeutic style.</p>
                    </div>
                    <img src={Tracy} className='twoimg port' />
                </div>
                <br /><br /><br />
                <hr />
                <div className='mission'>
                    <h2>Our Mission</h2>
                    <p>To provide competent supervision by promoting the professional development and skills enhancement of psychotherapists to create safety for their clients.</p>
                </div>
                <br /><br /><br /><br />
            </motion.div>
        )
    }
}

export default CSStory;